<template>
    <div class="person">
        <div class="condition">
            <queryCondition ref="query" :list="queryList" :value="conditionData" labelWidth="120px" :search="selectData" :reset="reset"></queryCondition>
        </div>
        <div class="table">
            <div class="handle">
                <el-button type="" icon="el-icon-refresh-left" size="small" @click="loadingData()">刷新列表</el-button>
                <div>
                </div>
            </div>
            <el-table
                :data="tableData"
                border
                :header-cell-style="tableHeaderColor"
                :default-expand-all="false"
                style="width: 100%">
                
                <el-table-column type="index" width="60" label="序号" align="center"></el-table-column>
                <el-table-column prop="userId" label="用户ID" align="center"></el-table-column>
                <el-table-column prop="nickName" label="用户昵称" align="center"></el-table-column>
                <!-- <el-table-column prop="phone" label="手机号" align="center"></el-table-column> -->
                <el-table-column prop="header" label="头像" align="center">
                    <template slot-scope="scope">
                        <el-image
                        style="width: 40px; height: 40px"
                        :src="scope.row.header"
                        :preview-src-list="[scope.row.header]"
                        v-if="scope.row.header"
                        fit="cover"></el-image>
                    </template>
                </el-table-column>
                <el-table-column prop="userFileType" label="文件类型" align="center">
                    <template slot-scope="scope">
                        <span v-if="scope.row.userFileType == 1">语音</span>
                        <span v-if="scope.row.userFileType == 2">视频</span>
                    </template>
                </el-table-column>
                <el-table-column prop="userFileState" label="审核状态" align="center">
                    <template slot-scope="scope">
                        <el-tag type="warning" v-if="scope.row.userFileState == 0">待审核</el-tag>
                        <el-tag type="success" v-if="scope.row.userFileState == 1">审核通过</el-tag>
                        <el-tag type="danger" v-if="scope.row.userFileState == -1">不通过</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="filePath" label="文件" align="center" width="200">
                    <template slot-scope="scope">
                        <div v-if="scope.row.userFileType == 1 && scope.row.filePath">
                            <el-button type="text" icon="el-icon-zoom-in" size="mini" @click="isOpen(scope.row)">点击打开</el-button>
                        </div>
                        <div v-if="scope.row.userFileType == 2 && scope.row.filePath">
                            <video :src="scope.row.filePath" class="table-video" @click="isOpen2(scope.row)"></video>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="fileTimeLength" label="文件长度" align="center" width="120">
                    <template slot-scope="scope">
                        <div v-if="scope.row.userFileType == 1">
                            {{ scope.row.fileTimeLength }}s
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="creationTime" label="创建时间" align="center" width="160"></el-table-column>
                <el-table-column fixed="right" label="操作" width="120" align="center">
                    <template slot-scope="scope">
                        <el-button type="text" icon="el-icon-edit" size="mini" @click="isDetailDialogShow(scope.row)">审核</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="page">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    background
                    layout="sizes, prev, pager, next, jumper"
                    :total="totalCount"
                    :page-sizes="[10, 20, 50, 100]"
                    :current-page="conditionData.page"
                    :page-size="conditionData.pageSize">
                </el-pagination>
            </div>
        </div>
        
        <el-dialog :close-on-click-modal="false" :visible.sync="isDetailDialog" title="查询详情" width="750px">
            <div class="dialog">
                <div class="item">
                    <div class="label">
                        认证状态
                    </div>
                    <div class="value">
                        <el-radio v-model="detailData.userFileState" :label="-1">不通过</el-radio>
                        <el-radio v-model="detailData.userFileState" :label="1">审核通过</el-radio>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        理由
                    </div>
                    <div class="value">
                        <el-input v-model="detailData.remark" size="small" placeholder="请输入" type="textarea" :rows="5"></el-input>
                    </div>
                </div>
                <div class="btns">
                    <el-button type="primary" @click="submitData">确实提交</el-button>
                </div>
            </div>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" :visible.sync="isOpenDialog" :title="openData.nickName+'-'+openData.phone" width="400px">
            <div class="dialog">
                <audio controls="controls" ref="audio">
                    <source src="" type="audio/mpeg">
                </audio>
            </div>
        </el-dialog>
        
        
    </div>
</template>
<script>
import api from '../../../api/main'
import queryCondition from '../../../components/queryCondition'
import forms from '../../../components/form'
import {parseTimeS} from '../../../utils/index'
  

export default {
    name: 'person',
    components:{
        queryCondition,
        forms,
    },
    watch: {
    },
    data () {
        return {
            isAddDialog:false,
            isUpdateDialog:false,
            isDetailDialog:false,
            formData:{},
            totalCount:0,
            // tableData:[],
            tableData: [
                
            ],
            detailData:{
                "id": null,
                "userFileState": null,
                "remark": ""
            },
            conditionData:{
                userId: "",
                userFileType: "",
                userFileState: "",
                pageSize: 10,
                page: 1
            },
            queryList:[
                {type: "input",label: "用户ID:",name: "userId"},
                {type: "input",label: "文件类型:",name: "userFileType"},
                {type: "input",label: "状态:",name: "userFileState"},
            ],
            openData:{},
            isOpenDialog:false,
        }
    },
    created(){
    },
    mounted(){
        if(this.$route.query.id){
            this.conditionData.snapMsgId = parseFloat(this.$route.query.id)
        }
        this.loadingData();
    },
    methods:{
        isOpen(row){
            this.openData =row;
            this.isOpenDialog = true;
            let _this = this;
            setTimeout(function(){
                _this.$refs.audio.src=row.filePath
            },300)
            this.$forceUpdate();
        },
        isOpen2(row){
            window.open(row.filePath, '_blank')
        },
        // table表头样式
        tableHeaderColor ({ row, column, rowIndex, columnIndex }) {
            if (rowIndex === 0) {
                return 'background-color: #F2F2F2;color: #000;'
            }
        },
        // 加载table数据
        async loadingData() {
            let res  = await api.QueryUserInfoFile(this.conditionData);
            this.tableData = res.data.data.data;
            this.totalCount = res.data.data.totalCount;
            // for(let index = 0;index<tableData.length;index++){
            //     tableData[index].creatTimeStr = parseTimeS(tableData[index].creatTime)
            // }
        },
        // 查询
        selectData(){
            this.conditionData.page = 1;
            this.loadingData();
        },
        // 重置查询
        reset(){
            this.conditionData = {
                phone: "",
                userFileType: "",
                userFileState: "",
                pageSize: 10,
                page: 1
            },
            this.loadingData();
        },
        // 切换页面
        handleCurrentChange(page){
            this.conditionData.page = page;
            this.loadingData();
        },
        // 切换页面条数
        handleSizeChange(pageSize){
            this.conditionData.page = 1;
            this.conditionData.pageSize = pageSize;
            this.loadingData();
        },
        showAddDialog(){
            this.isAddDialog = true;
        },
        async isDetailDialogShow(row){
            this.isDetailDialog = true;
            this.detailData = row;
        },
        async submitData(){
            let res = await api.UpdateUserFileState(this.detailData);
            if(res.data.code == '200'){
                this.$message({
                    type: 'success',
                    message: '修改成功'
                })
                this.isDetailDialog = false;
                this.loadingData();
                this.detailData = {
                    "id": null,
                    "userFileState": null,
                    "remark": ""
                }
            }
        }
    }
    
}
</script>

<style lang="scss" scoped>
    .person{
        height: 700px;
    }
    .condition{
        background-color: #ffffff;
        display: flex;
        align-items: center;
        border-radius: 5px;
        padding: 15px;
        padding-top: 30px;
        font-size: 14px;
    }
    .table{
        margin-top: 10px;
        background-color: #ffffff;
        padding: 15px;
        .handle{
            width: 100%;
            display: flex;
            justify-content: space-between;
            padding-bottom: 15px;
            align-items: center;
            font-size: 20px;
        }
        .page{
            display: flex;
            align-items: center;
            justify-content: center;
            margin-top: 16px;
            .el-pagination{
                margin-left: -10px;
            }
        }
    }
    .table-audio{

    }
    .table-video{
        width: 40px;
        height: 40px;
    }
</style>
